import { ZonePolygonData } from '@hakimo-ui/hakimo/ui-elements';
import { MutableRefObject } from 'react';

/**
 * Checks if a zone is new (not yet saved to the server)
 */
export function isNewZone(
  zoneId: string,
  initialZoneIdsRef: MutableRefObject<Set<string>>
): boolean {
  return !initialZoneIdsRef.current.has(zoneId);
}

/**
 * Gets the initial state of a zone for resetting
 */
export function getInitialZone(
  zoneId: string,
  initialZonesRef: MutableRefObject<ZonePolygonData[]>
): ZonePolygonData | undefined {
  return initialZonesRef.current.find((z) => z.id === zoneId);
}

/**
 * Removes a zone from the zones array
 */
export function removeZone(
  zones: ZonePolygonData[],
  zoneId: string
): ZonePolygonData[] {
  return zones.filter((z) => z.id !== zoneId);
}

/**
 * Resets a zone to its initial state in the zones array
 */
export function resetZoneToInitial(
  zones: ZonePolygonData[],
  zoneId: string,
  initialZone: ZonePolygonData
): ZonePolygonData[] {
  return zones.map((z) => (z.id === zoneId ? { ...initialZone } : z));
}

/**
 * Updates a zone's initial state after save
 */
export function updateInitialZonesAfterSave(
  initialZonesRef: MutableRefObject<ZonePolygonData[]>,
  initialZoneIdsRef: MutableRefObject<Set<string>>,
  zone: ZonePolygonData,
  isNew: boolean
): void {
  if (isNew) {
    initialZonesRef.current = [...initialZonesRef.current, zone];
    initialZoneIdsRef.current.add(zone.id);
  } else {
    initialZonesRef.current = initialZonesRef.current.map((z) =>
      z.id === zone.id ? { ...zone } : z
    );
  }
}

/**
 * Removes a zone from initial zones tracking after delete
 */
export function removeFromInitialZones(
  initialZonesRef: MutableRefObject<ZonePolygonData[]>,
  initialZoneIdsRef: MutableRefObject<Set<string>>,
  zoneId: string
): void {
  initialZonesRef.current = initialZonesRef.current.filter(
    (z) => z.id !== zoneId
  );
  initialZoneIdsRef.current.delete(zoneId);
}
